﻿import React, { useContext, useState, useEffect } from 'react';
import URLSearchParams from '@ungap/url-search-params'

import ListItem from './ListItem'

const ListWidget = ({ setFacilitySearchContext, facilitySearchContext, viewToggle }) => {
  const lang = {
    ...facilitySearchContext.localization.headings,
    ...facilitySearchContext.localization.inputs,
    ...facilitySearchContext.localization.messages
  };

  //const selectedPlace = facilitySearchContext.focusedFacility;
  const visibleFacilities = facilitySearchContext.visibleFacilities;
  const filteredFacilities = facilitySearchContext.filteredFacilities;
  const [heading, setHeading] = useState('');
  const [list, setList] = useState([]);
  const [listUpdate, setListUpdate] = useState(null);
  const [showMore, setShowMore] = useState(false);
  const [listItemsToShow, setListItemsToShow] = useState(10);
  const [date, setDate] = useState(facilitySearchContext.searchDate);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const searchQuery = urlParams.get('name');
    const initialValue = (facilitySearchContext.selectedLocation && facilitySearchContext.selectedLocation.name) ?? searchQuery;
    setHeading(initialValue === 'georesult' ? lang.georesult : initialValue);
  }, [facilitySearchContext])

  useEffect(() => {
    if (!filteredFacilities || ((window.innerWidth > 988 || viewToggle === 'map') && (!visibleFacilities || (list.length === 0 && visibleFacilities === null))))
      return;
    setList(window.innerWidth > 988 ? visibleFacilities : visibleFacilities ? Array.from(new Set([...visibleFacilities, ...filteredFacilities])) : filteredFacilities);
    setListUpdate(visibleFacilities);
    setListItemsToShow(10);
  }, [visibleFacilities, filteredFacilities]);

  useEffect(() => {
    if (facilitySearchContext.setListEmpty) {
      setList([]);
      setListUpdate(visibleFacilities);
    }
  }, [facilitySearchContext.setListEmpty])

  useEffect(() => {
    if ((window.innerWidth < 989 && (viewToggle === 'list' || facilitySearchContext.visibleFacilities === null)) || ((window.innerWidth > 988 || viewToggle === 'map') && (list.length === 0 || facilitySearchContext.showLoadingScreen || facilitySearchContext.visibleFacilities?.length === 0))) return;
    setFacilitySearchContext({ ...facilitySearchContext, panOnLoad: false, filterOnInit: false });
  }, [listUpdate, viewToggle])

  useEffect(() => {
    setDate(facilitySearchContext.searchDate);
  }, [facilitySearchContext.searchDate])

  return (
    <div data-view-toggled={viewToggle === 'list' ? true : false} className="facilitysearchpage__wrapper__list">
      {list.length > 0 && (
        <ul className="facilitysearchpage__list">
          {list.slice(0, listItemsToShow).map((place, i) => {
            const loadProductInformation = facilitySearchContext.customerService && facilitySearchContext.customerServiceDate && i <= listItemsToShow - 1;
            const notesForZones = place.ParkingZones.map((pz) => ({ filteredNotes: pz.FilteredNotes, ZoneId: pz.Uid }));
            //console.log('place', place)
            //console.log('notesForZones', notesForZones)
            return <ListItem key={place.Uid} facility={place} facilitySearchContext={facilitySearchContext} setFacilitySearchContext={setFacilitySearchContext} uid={place.Uid} url={place.Url} name={place.Name} location={heading} address={place.Address} filteredNotes={place.FilteredNotes} notesForZones={notesForZones} distance={place.Address.Distance} date={date} loadProductInformation={loadProductInformation} />
          })}
        </ul>
      )}
      {list.length > listItemsToShow && (
        <div className={['facilitysearchpage__show-more', showMore ? 'facilitysearchpage__show-more--showall' : null].join(' ')}>
          <button className="facilitysearchpage__show-more__cta" onClick={() => setListItemsToShow(listItemsToShow + 10)}>{lang.showmore}</button>
        </div>
      )}
      {list.length === 0 && !facilitySearchContext.showLoadingScreen && !facilitySearchContext.panOnLoad && !facilitySearchContext.filterOnInit && (
        <div className="facilitysearchpage__list__empty">
          <div>
            <h2>{lang.emptyresult.heading}</h2>
            <p>{lang.emptyresult.text}</p>
          </div>
        </div>
      )}
      {list.length === 0 && (facilitySearchContext.showLoadingScreen || facilitySearchContext.panOnLoad || facilitySearchContext.filterOnInit) && (
        <div className="facilitysearchpage__list__empty">
          <div>
            <h2>{lang.loading.heading}</h2>
            <p>{lang.loading.text}</p>
          </div>
        </div>
      )}
    </div>
  )
}

export default ListWidget;
